import { adminHttpClient } from "../../commons/adminHttpClinet";
import { Statistics } from "../../models/dashboard/statistics";

const getStatistics = (): Promise<Statistics> => {
    return adminHttpClient.get("/api/Admin/AdminStatistics/get-admin-statistics")
}

export default getStatistics;